import { makeStyles } from 'tss-react/mui';

export const useDeleteModalStyles = makeStyles({ name: 'DeleteModal' })(theme => ({
  deleteModalActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  paperWidthXs: {
    maxWidth: '343px',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
}));
